'use client'

import ArrowCurve from '@/components/illustratores/ArrowCurve';
import Image from 'next/image';

export default function PartnershipAdventages({ assetBase }: { assetBase: string }) {
    return (
        <div className='relative lg:mt-12 '>
            <ArrowCurve className="w-8 xl:w-12 h-12 absolute right-14 top-28 lg:block hidden" />
            <ArrowCurve className="w-8 xl:w-12 h-12 absolute -left-20 bottom-32 lg:block hidden rotate-180" />
            <div className="text-center pb-4 md:pb-8 my-container">
                <h1 className="text-xl md:text-4xl font-medium">
                    Why Join Planin<span className='text-red-500'>Go</span>’s
                    <span className='font-bold inline-block ml-1'>

                        Influencer Market Place?
                    </span>
                </h1>
                <p className=" text-neutral-500 mt-4 lg:block hidden">
                    It&apos;s easy, it&apos;s rewarding, it&apos;s all you need. Your time to touch &rdquo;millions of subscribers.
                </p>
            </div>
            <div className=" grid-flow-row flex flex-col md:gap-2 gap-12">
                <div className='flex flex-col md:flex-row md:even:flex-row-reverse gap-10 lg:gap-16'>
                    <div className='w-full md:w-1/2'>
                        <Image
                            className="h-fit mx-auto w-4/5 md:w-[40dvw] object-contain"
                            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/faa75a8a-931e-418b-8cbd-2c33badc309d-planingo.png`}
                            width={600}
                            height={400}
                            alt="its more that trip"
                        />
                    </div>
                    <div className='flex flex-col items-center md:items-start justify-center md:gap-4 w-full md:w-1/2'>
                        <h1 className='sm:text-2xl lg:text-4xl font-bold'>Earn Money & Points</h1>
                        <p className='text-sm text-center md:text-left md:text-base font-normal text-neutral-600'>Turn every referral, booking, and engagement into real money or points you can redeem for exclusive perks.</p>
                    </div>
                </div>
                <div className='flex flex-col md:flex-row md:even:flex-row-reverse md:gap-16 '>
                    <div className='w-full md:w-1/2'>
                        <Image
                            className="h-fit mx-auto w-4/5 md:w-[40dvw] object-contain"
                            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/218c4b2d-d726-43ee-a58a-3ba56cf288cd-planingo.png`}
                            width={600}
                            height={400}
                            alt="its more that trip"
                        />
                    </div>
                    <div className='flex flex-col items-center md:items-start justify-center md:gap-4 w-full md:w-1/2'>
                        <h1 className='sm:text-2xl lg:text-4xl font-bold'>Lodge Like a Boss</h1>
                        <p className='text-sm text-center md:text-left md:text-base font-normal text-neutral-600'>Enjoy free stays, exclusive travel perks, and unforgettable experiences as a PlaninGo partner. Travel more, pay less!</p>
                    </div>

                </div>
                <div className='flex flex-col md:flex-row md:even:flex-row-reverse md:gap-16'>
                    <div className='w-full md:w-1/2'>
                        <Image
                            className="h-fit mx-auto w-4/5 md:w-[40dvw] object-contain"
                            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/01b8592f-287c-4a7f-ada4-da6720ed0abc-planingo.png`}
                            width={600}
                            height={400}
                            alt="its more that trip"
                        />
                    </div>
                    <div className='flex flex-col items-center md:items-start justify-center md:gap-4 w-full md:w-1/2'>
                        <h1 className='sm:text-2xl lg:text-4xl font-bold'>Create & Go Viral</h1>
                        <p className='text-sm text-center md:text-left md:text-base font-normal text-neutral-600'>Turn your adventures into content gold and grow your follower count faster than ever.</p>
                    </div>
                </div>
            </div>

        </div>
    );
}